// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
    getMessaging,
    getToken,
    Messaging
} from 'firebase/messaging';

const firebaseConfig = process.env.REACT_APP_FIREBASE_CONFIG ? JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG) : {};
// console.log('chk10', firebaseConfigStr);


// if (!firebaseConfigStr) {
//     throw new Error("FIREBASE_CONFIG is not defined");
// }

// const firebaseConfig: any = (firebaseConfigStr)

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging: Messaging = getMessaging(app);

// Function to retrieve the FCM token using your VAPID key 
const requestForToken = async (): Promise<string | null> => {
    try {
        const vapidKey = process.env.REACT_APP_VAPID;
        const currentToken = await getToken(messaging, { vapidKey });
        if (currentToken) {
            console.log('FCM Registration Token:', currentToken);
            return currentToken;
        } else {
            console.log('No registration token available. Request permission to generate one.');
            return null;
        }
    } catch (error) {
        console.error('Error retrieving FCM token:', error);
        return null;
    }
};

// Handle foreground messages


// onMessage(messaging, (payload) => {
//     const { title, body } = payload.notification || {};

//     toast.custom((t) => (
//         <div className={`custom-toast ${t.visible ? 'enter' : 'leave'}`}>
//             <div className="left-border" />
//             <div className="toast-content">

//                 <div className="toast-title"><span className="pe-2"><FaInfoCircle style={{ color: '#3b82f6' }} size={17} /></span>{title || 'Notification'}</div>
//                 <div className="toast-message">{body || 'You have a new message'}</div>
//             </div>
//             <button className="close-button" onClick={() => toast.dismiss(t.id)}>×</button>
//         </div>
//     ));
// });


export { messaging, requestForToken };
